import type { ComponentProps, PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import IcChevronRight from 'src/assets/images/icChevronRightBold.svg';
import { useInventoryItem } from 'src/hooks/useInventoryItem';
import { EVENT_TYPE } from 'src/types/Event';
import { pushEvent } from 'src/utils/event-gateway';
const Root = styled.button`
  all: unset;
  display: flex;
  cursor: pointer;
  flex-direction: row;
  gap: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const RootStyles = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  min-width: 64px;
  max-width: 120px;
  padding: 2px 6px;
  min-height: 24px;
  text-align: center;
  width: max-content;
  border-radius: 8px;
  background: ${({
  theme
}) => theme.color.surface4};

  color: ${({
  theme
}) => theme.color.content11};
  font-size: 13px;
  font-weight: 700;
`;
const CaretIcon = styled(IcChevronRight)`
  width: 16px;
  height: 16px;
`;
interface Props extends Pick<ComponentProps<'button'>, 'onClick' | 'className'> {
  target: 'regionfilter' | 'agefilter' | 'languagefilter' | 'shuffle' | 'genderfilter';
}
export default function FilterButton(props: PropsWithChildren<Props>) {
  const {
    onClick,
    children,
    className,
    target
  } = props;
  const {
    itemId
  } = useInventoryItem(({
    categoryId
  }) => categoryId === 'VIVIDI_UNLIMITED') ?? {};
  const isSubscribed = !!itemId;
  const handleClick: ComponentProps<'button'>['onClick'] = event => {
    pushEvent({
      eventType: EVENT_TYPE.MIRROR,
      eventName: `mirror__click_${target}`,
      eventParams: {
        action_category: 'click',
        tab: 'mirror',
        page: 'mirror',
        target,
        is_subscribed: isSubscribed,
        subscribed_product_id: itemId
      }
    });
    onClick?.(event);
  };
  return <Root onClick={handleClick} data-sentry-element="Root" data-sentry-component="FilterButton" data-sentry-source-file="FilterButton.tsx">
      <RootStyles className={className} data-sentry-element="RootStyles" data-sentry-source-file="FilterButton.tsx">{children}</RootStyles>
      <CaretIcon data-sentry-element="CaretIcon" data-sentry-source-file="FilterButton.tsx" />
    </Root>;
}